import { render, staticRenderFns } from "./batchSerialUpdateImport.vue?vue&type=template&id=b6ebd52a&scoped=true&"
import script from "./batchSerialUpdateImport.vue?vue&type=script&lang=js&"
export * from "./batchSerialUpdateImport.vue?vue&type=script&lang=js&"
import style0 from "./batchSerialUpdateImport.vue?vue&type=style&index=0&id=b6ebd52a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ebd52a",
  null
  
)

export default component.exports